module.exports = __webpack_public_path__ + "static/media/cherry.0079207f.png";